import { Logger } from "@vm/logger";

import frontend from "./env/frontend";

export const loggerOptions = {
  level: frontend.LOG_LEVEL,
};

export const logger = new Logger(loggerOptions);
